import {
    type FC
} from "react";
import type IComposerActionsProps from "./type";
import {
    warnOnce
} from "../../../../utils/development";

const ComposerActions: FC<IComposerActionsProps> = () => {
    warnOnce({
        message: "Composer.Actions: render it as a direct child of Composer; its children are placed in the toolbar."
    });

    return null;
};
export default ComposerActions;
